var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-5" }, [
    _c("h3", { staticClass: "mb-5 text-lg" }, [_vm._v("Fakturační údaje")]),
    _vm._v(" "),
    _c("div", { staticClass: "flex mb-4 space-x-5" }, [
      _c("div", { staticClass: "w-1/2 border-b border-black" }, [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "text",
            placeholder: "E-mail",
            required: "",
            name: "billing_email"
          },
          domProps: { value: _vm.address.email }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow border-b border-black" }, [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "phone",
            placeholder: "Telefon",
            name: "billing_phone"
          },
          domProps: { value: _vm.address.phone }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex mb-4 space-x-5" }, [
      _c("div", { staticClass: "w-1/2 border-b border-black" }, [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "text",
            placeholder: "Jméno",
            name: "billing_first_name"
          },
          domProps: { value: _vm.address.first_name }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow border-b border-black" }, [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: {
            type: "text",
            placeholder: "Příjmení",
            name: "billing_last_name"
          },
          domProps: { value: _vm.address.last_name }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex mb-4 space-x-5" }, [
      _c("div", { staticClass: "flex w-1/2 space-x-5" }, [
        _c("div", { staticClass: "w-3/4 border-b border-black" }, [
          _c("input", {
            staticClass:
              "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
            attrs: {
              type: "text",
              placeholder: "Ulice + č. p.",
              name: "billing_address_1"
            },
            domProps: { value: _vm.address.address_1 }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-grow border-b border-black" }, [
          _c("input", {
            staticClass:
              "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
            attrs: {
              type: "text",
              placeholder: "PSČ",
              name: "billing_postcode"
            },
            domProps: { value: _vm.address.postcode }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow border-b border-black" }, [
        _c("input", {
          staticClass:
            "w-full pb-2 pl-2 outline-none placeholder-brandGray focus:outline-none",
          attrs: { type: "text", placeholder: "Město", name: "billing_city" },
          domProps: { value: _vm.address.city }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex space-x-5" }, [
      _c("div", { staticClass: "flex items-center w-1/2" }, [
        _c(
          "label",
          {
            staticClass: "flex items-center",
            attrs: { for: "ship-to-different-address-checkbox" }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sameAddress,
                  expression: "sameAddress"
                }
              ],
              staticClass: "hidden pr-4",
              attrs: {
                id: "ship-to-different-address-checkbox",
                type: "checkbox"
              },
              domProps: {
                checked: Array.isArray(_vm.sameAddress)
                  ? _vm._i(_vm.sameAddress, null) > -1
                  : _vm.sameAddress
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.sameAddress,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.sameAddress = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.sameAddress = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.sameAddress = $$c
                    }
                  },
                  _vm.sameAddressChange
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "relative inline-flex items-center justify-center w-4 h-4 mr-2 border rounded border-brandGray",
                class: {
                  "bg-almostBlack": _vm.sameAddress
                }
              },
              [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.sameAddress,
                      expression: "sameAddress"
                    }
                  ],
                  staticClass: "absolute",
                  attrs: {
                    src: require("../../../images/checkmark.svg").default,
                    alt: "Checkmark"
                  }
                })
              ]
            ),
            _vm._v("\n        Dodací údaje stejné jako fakturační\n        "),
            _c("input", {
              attrs: { type: "hidden", name: "ship_to_different_address" },
              domProps: { value: _vm.sameAddress ? "0" : "1" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex flex-grow border-b border-black" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.country,
                expression: "country"
              }
            ],
            staticClass: "w-full",
            attrs: { name: "billing_country", id: "" },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.country = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function($event) {
                  return _vm.countryChange()
                }
              ]
            }
          },
          _vm._l(_vm.countries, function(country, key) {
            return _c(
              "option",
              { key: "billing-country-" + key, domProps: { value: key } },
              [_vm._v("\n          " + _vm._s(country) + "\n        ")]
            )
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    !_vm.loggedIn
      ? _c("div", { staticClass: "flex items-center w-1/2" }, [
          _c(
            "label",
            {
              staticClass: "flex items-center",
              attrs: { for: "create-account-checkbox" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.createAccount,
                    expression: "createAccount"
                  }
                ],
                staticClass: "hidden pr-4",
                attrs: { id: "create-account-checkbox", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.createAccount)
                    ? _vm._i(_vm.createAccount, null) > -1
                    : _vm.createAccount
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.createAccount,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.createAccount = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.createAccount = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.createAccount = $$c
                      }
                    },
                    _vm.createAccountChanged
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "relative inline-flex items-center justify-center w-4 h-4 mr-2 border rounded border-brandGray",
                  class: {
                    "bg-almostBlack": _vm.createAccount
                  }
                },
                [
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.createAccount,
                        expression: "createAccount"
                      }
                    ],
                    staticClass: "absolute",
                    attrs: {
                      src: require("../../../images/checkmark.svg").default,
                      alt: "Checkmark"
                    }
                  })
                ]
              ),
              _vm._v("\n      Chci se registrovat\n      "),
              _c("input", {
                attrs: { type: "hidden", name: "createaccount" },
                domProps: { value: _vm.createAccount ? "1" : "0" }
              })
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/checkout/BillingFields.vue?vue&type=template&id=5b7849ff&
// module id = 152
// module chunks = 0